import { useActiveCompanyId } from './active-company';
import { useMyCompanies, useSubscription } from './companies';

/**
 * Whether the signed-in user may change the active company's data. The server
 * enforces the same rule on every write (@CompanyWrite()); this only decides
 * which controls to show. False for a read_only member and while the
 * company's subscription is read-only. A company with no subscription
 * (free modules) can still edit.
 */
export function useCanEdit(): boolean {
  const companyId = useActiveCompanyId();
  const companies = useMyCompanies();
  const subscription = useSubscription(companyId);
  const role = companies.data?.find((c) => c.id === companyId)?.role;
  return role !== 'read_only' && !subscription.data?.isReadOnly;
}
